function GotoB2B() {
  window.open(process.env.REACT_APP_B2B_APP_URL, '_blank')?.focus();
  return;
}

export default GotoB2B;
